"use strict";

exports.__esModule = true;
// This will need to keep in sync with the `ReactCSSTransitionGroupChild` `TICK` const.
// https://github.com/facebook/react/blob/master/src/addons/transitions/ReactCSSTransitionGroupChild.js#L22

exports.default = 17;


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/constants/CSSTransitionGroupTick.js
// module id = 29
// module chunks = 168707334958949